import React from 'react';

import BusLoader from '../BusLoader/BusLoader';

import styles from './Interstitial.scss';

function Interstitial() {
    return (
        <BusLoader
            className={styles.busLoader}
            large
        />
    );
}

export default Interstitial;
